import Auth0Lock from 'auth0-lock';
import iconLogo from '../../images/LogowithoutWords.png';
import history from '../../config/history';

import { loginServices } from '../../graphql/serviceAuthentication'
import { logoutAfterLoginFailure } from '../../utils/authUtils'

// Initialize the lock widget
const lock = new Auth0Lock(
  process.env.REACT_APP_AUTH0_CLIENT_ID,
  process.env.REACT_APP_AUTH0_DOMAIN,
  {
    auth: {
      redirect: false,
      responseType: 'token id_token', // Return the id token (jwt) in the auth response
    },

    languageDictionary: {
      title: 'ICON Platform',
      loginLabel: 'LOG IN',
      passwordInputPlaceholder: '••••••••',
      forgotPasswordAction: 'Reset password'
    },
    theme: {
      logo: iconLogo,
      primaryColor: '#F04E3F',
      buttonText: '#ffffff',
      borderRadius: 2,
      inputBorderColor: '#F04E3F',
      inputBorderColorFocus: '#F04E3F',
      inputPlaceholderColor: '#999999',
    },
    autoclose: false,
  },
);

// Track if we've set up the listener
let isListenerSetup = false;
let currentResolve = null;
let currentReject = null;

// Set up the authenticated listener once
if (!isListenerSetup) {
  lock.on('authenticated', async authResult => {
    try {
      console.log('Auth0 authenticated event received');

      // Set id token in cookie
      document.cookie = `idToken=${authResult.idToken}`;

      // Call loginServices with timeout to prevent infinite loading
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Login services timeout after 30 seconds')), 30000);
      });

      const loginServicesPromise = loginServices();

      let res;
      try {
        res = await Promise.race([loginServicesPromise, timeoutPromise]);
      } catch (err) {
        console.error('Login services error:', err);
        lock.hide();
        logoutAfterLoginFailure(err);
        if (currentReject) {
          currentReject(err);
        }
        return;
      }

      // Always hide the lock after processing
      lock.hide();

      // Check if login was successful
      if (!res || !res.loginServices || !res.loginServices.status || res.loginServices.status !== "success") {
        console.error('Login services returned failure:', res);
        logoutAfterLoginFailure(res);
        if (currentReject) {
          currentReject(new Error('Login services failed'));
        }
        return;
      }

      // Successful login - check for redirect URL
      const redirectUrl = sessionStorage.getItem('auth_redirect_url');
      if (redirectUrl) {
        sessionStorage.removeItem('auth_redirect_url');
        history.push(redirectUrl);
      }

      // Resolve the promise
      if (currentResolve) {
        currentResolve(authResult.idToken);
      }
    } catch (err) {
      console.error('Unexpected error during authentication:', err);
      lock.hide();
      if (currentReject) {
        currentReject(err);
      }
    }
  });

  // Handle authorization errors
  // Note: We don't hide the lock here because Auth0 Lock handles displaying
  // error messages (like wrong password) internally. Hiding the lock would
  // prevent users from seeing these error messages.
  lock.on('authorization_error', (error) => {
    console.error('Auth0 authorization error:', error);
    // Don't hide the lock - let Auth0 Lock display the error message
    // Only reject the promise for error tracking, but keep the lock open
    if (currentReject) {
      currentReject(error);
    }
  });

  isListenerSetup = true;
}

// Create a new promise each time this is called
lock.getAuthorizedPromise = () => new Promise((resolve, reject) => {
  currentResolve = resolve;
  currentReject = reject;
});

// Create initial promise for backward compatibility
lock.authorizedPromise = lock.getAuthorizedPromise();

export default lock;



// WEBPACK FOOTER //
// ./src/components/Auth/lock.js